import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCargoItem = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M16 2H0v5h16zM4 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16 9H0v5h16zM3 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clipRule="evenodd" />
  </svg>
);
export default SvgCargoItem;
